// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import Header from '@/components/Header.vue'
import EditUserBill from '@/components/EditUserBill.vue'
import { userBillFactory } from '@/http/user-bill'
import { masterDataFactory } from '@/http/master-data'
import { customerFactory } from '@/http/customer'
import { setupFactory } from '@/http/setup'
import swal from 'sweetalert'
import constants from '@/constants/constants'
import Utils from '@/utils/utils'
import token from '@/constants/token'
import roleAccessManager from '@/utils/role-access-manager'
import router from '@/router/index'
import CurrencyInputDisable from '@/components/CurrencyInputDisable.vue'
import * as bootstrap from 'bootstrap'
import { usFactory } from '@/http/uang-sekolah'

declare let snap: any
declare let loadSnapJS: any

@Options({
  components: {
    Header,
    EditUserBill,
    CurrencyInputDisable
  },
  data () {
    return {
      instance: '',
      userBills: [],
      statuses: [],
      stats: {
        total_bill: 0,
        total_paid: 0
      },
      months: [],
      schoolYears: [],
      math_operations: [],
      school: {
        name: ''
      },
      totalUnpaid: 0,
      readMoreActivated: false,
      canUpdate: false,
      param: {
        school_year_id: 0
      },
      user_id: this.$route.params.user_id,
      data: {
        bill_name: '',
        bill_month: '',
        details: [],
        total_amount: 0,
        fine_rules: {
          value: 0,
          type: 'nominal',
          formula: 'flat'
        },
        description: '',
        due_date: null,
        dateline_date: null,
        is_published: '',
        state: '',
        user_updated: {
          name: ''
        },
        updated_at: '',
        log: []
      },
      data_master: {
        school_years: '1',
        months: '1',
        school: '1',
        math_operations: '1'
      },
      user: {
        name: '',
        class_name: '',
        parents_father: '',
        parents_mother: '',
        user_profile_no_hp: '',
        student_profile_nis: '',
        status: 'Inactive'
      },
      currentSort: 'name',
      currentSortDir: 'asc',
      path: process.env.VUE_APP_STORAGE_PATH,
      imagepath: '',
      subdomain: token.user.subdomain,
      constants: constants,
      searchField: '',
      billIds: [] as any[],
      allSelectedBill: false,
      loading: [] as any[],
      loadingBulk: false,
      convenienceFee: [] as any[],
      convenience_id: 0,
      paymentMethod: true,
      config: {
        currency: 'IDR',
        currencyDisplay: 'symbol'
      },
      payment: {
        amount: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        total_amount: 0
      },
      tempCheckout: {
        ids: [] as any[],
        type: ''
      },
      convenienceFeeModal: null as any,
      xenditModal: null as any,
      bcaModal: null as any,
      bca: {
        orderId: '',
        invoice_number: '',
        va_number: '',
        va_number_nobill: '',
        bank_name: '',
        amount: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        total_payment: 0
      },
      xenditInvoice: '',
      orderId: null as any,
      canUploadReference: false,
      referenceFile: null as any,
      setting: {} as any,
      userOrders: [] as any[],
      totalLateCharge: 0,
      groupBillAsTab: false,
      billTypes: [] as any[],
      useImportVA: false,
      disableCheckboxes: 'false',
      adminCanGeneratePayment: false
    }
  },
  methods: {
    onImageLoadFailure: function (event: any) {
      event.target.src = '/img/photos/default-avatar.png'
    },
    getMonth: function (date: any) {
      if (date != '' && date != undefined) {
        const d = date.split('-')
        const month = d[2]
        return this.months[month].id
      } else {
        return ''
      }
    },
    toLocaleString: function (val: any) {
      return Utils.toLocaleString(val)
    },
    edit: function (type: string, bill_id: any, bill_user_id: any) {
      Promise.resolve(userBillFactory.billUserDetail(bill_id, bill_user_id))
        .then(result => {
          const bill_user = result.data.bill_user
          const data = {
            id: bill_user.id,
            spp_bill_id: bill_user.spp_bill_id,
            school_year_id: bill_user.school_year_id,
            bill_name: bill_user.bill.name,
            bill_month: this.getMonth(bill_user.id),
            active_date: bill_user.active_date.substring(0, 10),
            deadline_date: new Date(bill_user.deadline_date.substring(0, 10)),
            due_date: new Date(bill_user.due_date.substring(0, 10)),
            total_amount: bill_user.total_amount,
            details: bill_user.details,
            description: bill_user.bill.description,
            is_published: (bill_user.is_published == 1),
            fine_rules: bill_user.bill.fine_rules,
            user_updated: bill_user.user_updated,
            log: bill_user.log,
            updated_at: Utils.beautifyDatetime(bill_user.updated_at)
          }
          if (bill_user.bill.fine_rules.length == 0) {
            const fine_rules = {
              value: 0,
              type: 'nominal',
              formula: 'flat'
            }
            data.fine_rules = fine_rules
          }
          this.data = data
          this.data.state = type
        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    },
    loadData: function () {
      Promise.all([
        userBillFactory.userBill(this.param, this.user_id)
      ]).then(results => {
        if (results[0].data.user_bills.length > 0) {
          const userData = results[0].data.user
          const user = {
            user_id: ('user_id' in userData) ? userData.user_id : 0,
            name: ('name' in userData) ? userData.name : '',
            class_name: ('class' in userData) ? ('name' in userData.class) ? userData.class.name : '' : '',
            parent_father: ('parents' in userData) ? ('father' in userData.parents) ? userData.parents.father : '' : '',
            parent_mother: ('parents' in userData) ? ('mother' in userData.parents) ? userData.parents.mother : '' : '',
            user_profile_no_hp: ('user_profile' in userData) ? ('no_hp' in userData.user_profile) ? userData.user_profile.no_hp : '' : '',
            student_profile_nis: ('student_profile' in userData) ? ('nis' in userData.student_profile) ? userData.student_profile.nis : '' : '',
            status: ('status' in userData) ? userData.status : 'Inactive'
          }
          this.user = user
          this.userBills = results[0].data.user_bills
          this.statuses = results[0].data.statuses
          this.stats = results[0].data.stats
          this.userBills.forEach((detail: any) => {
            const d = detail.id.split('-')
            detail.bill_month = parseInt(d[2])
            detail.bill_name = detail.bill.name
            detail.total_payment = detail.total_amount + detail.late_charge
            detail.total_unpaid = detail.total_payment - detail.total_paid
            detail.deadline_date = detail.deadline_date.substring(0, 10)
            detail.due_date = detail.due_date.substring(0, 10)
            detail.active_date = detail.active_date.substring(0, 10)
          })
          this.totalUnpaid = (this.stats.total_bill - this.stats.total_paid)
          const path = this.path + this.subdomain + '/student_photos/' + this.user.student_profile_nis + '.jpg'
          this.imagepath = path
        } else {
          this.userBills = []
        }
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    loadDataMaster: function () {
      Promise.all([
        masterDataFactory.master_datas(this.data_master)
      ]).then(results => {
        this.schoolYears = results[0].data.school_years
        this.months = results[0].data.months
        this.school = results[0].data.school
        this.math_operations = results[0].data.math_operations
        this.schoolYears.forEach((school_year: any) => {
          if (school_year.status == 'Active') {
            this.param.school_year_id = school_year.school_year_id
          }
        })
        this.loadData()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    sort: function (s: any) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    publishByID: function (bill: any, e: any) {
      swal({
        title: 'Apakah anda yakin?',
        text: (!bill.is_published) ? 'Tagihan ' + bill.bill.name + ' akan ditampilkan ke pengguna.' : 'Tagihan ' + bill.bill.name + ' batal ditampilkan ke pengguna.',
        icon: 'warning',
        buttons: {
          cancel: true,
          confirm: true
        },
        dangerMode: true
      })
        .then((willGenerate) => {
          if (willGenerate) {
            if (this.searchField.length == 0) {
              this.param.user_id = ''
            }
            if (this.param.user_id != '') {
              this.param.class_id = ''
            }
            const param = {
              is_published: !bill.is_published,
              school_year_id: this.param.school_year_id,
              spp_bill_user_id: bill.id
            }
            Promise.resolve(userBillFactory.userBillPublish(param))
              .then(results => {
                if (results.error == false) {
                  if (!bill.is_published) {
                    swal('Tagihan ' + bill.bill.name + ' ditampilkan ke ' + bill.user_name + '.', '', 'success')
                  } else {
                    swal('Tagihan ' + bill.bill.name + ' batal ditampilkan ke ' + bill.user_name + '.', '', 'success')
                  }
                  this.loadData()
                } else if (results.response.data.error == true) {
                  const errorMessage = results.response.data.messages
                  let msg = ''
                  for (const i in errorMessage) {
                    msg += errorMessage[i] + '<br>'
                  }
                  const length = 100
                  msg = msg.substring(0, length)
                  swal({
                    text: (!bill.is_published) ? 'Gagal menampilkan tagihan ke user' : 'Gagal membatalkan tagihan ke user',
                    icon: 'error',
                    content: {
                      element: 'p',
                      attributes: {
                        innerHTML: msg
                      }
                    }
                  })
                }
              }).catch((e) => {
                swal('Gagal melakukan request', '', 'error')
                console.log(e)
              })
          } else {
            const checkbox = e.target
            checkbox.checked = !checkbox.checked
          }
        })
    },
    checkAllBill: function () {
      this.allSelectedBill = !this.allSelectedBill
      if (this.allSelectedBill === true) {
        this.userBills.forEach((bill: any) => {
          if ((bill.status == constants.BILL_PENDING || bill.status == constants.BILL_UNPAID) && (bill.spp_order_ids == undefined || this.isCanceled(bill.spp_order_ids))) {
            if (!this.billIds.includes(bill.id)) {
              this.billIds.push(bill.id)
            }
          }
        })
      } else {
        this.billIds = []
      }
    },
    uncheckAllBill: function () {
      this.allSelectedBill = false
      this.billIds = []
    },
    isCanceled: function (order_ids: any) {
      if (order_ids == undefined) return true
      for (const i in order_ids) {
        const order_id = order_ids[i]
        const order = this.userOrders.find((o: any) => o.id == order_id)
        if (order && (order.status == constants.ORDER_CANCELED)) {
          return true
        }
      }
      return false
    },
    resetTempCheckout: function () {
      this.tempCheckout.ids = []
      this.tempCheckout.type = ''
    },
    setTempCheckout: function (ids: any, type: any) {
      this.tempCheckout.ids = ids
      this.tempCheckout.type = type
    },
    resetConvenienceFee: function () {
      this.paymentMethod = true
      this.convenience_id = 0
      const payment = {
        amount: 0,
        convenience_fee: 0,
        merchant_fee: 0,
        total_discount: 0,
        ppn: 0,
        total_amount: 0
      }
      this.payment = payment
    },
    showModal: function (modalId: string = 'convenience') {
      const element = document.getElementById(modalId + 'Modal')
      if (element) {
        if (modalId === 'convenience') {
          this.convenienceFeeModal = new bootstrap.Modal(element)
          this.convenienceFeeModal.show()
        } else if (modalId === 'xendit') {
          this.xenditModal = new bootstrap.Modal(element)
          this.xenditModal.show()
        } else if (modalId === 'bca') {
          this.bcaModal = new bootstrap.Modal(element)
          this.bcaModal.show()
        }
      }
    },
    hideModal: function (modalId: string = 'convenience') {
      if (modalId === 'convenience' && this.convenienceFeeModal) {
        this.convenienceFeeModal.hide()
      } else if (modalId === 'xendit' && this.xenditModal) {
        this.xenditModal.hide()
      } else if (modalId === 'bca' && this.bcaModal) {
        this.bcaModal.hide()
      }
    },
    handleConvenienceFee: function (convenience_id: any) {
      const selectedFee = this.convenienceFee.find((fee: any) => fee.id === convenience_id)
      if (selectedFee) {
        const totalBillAmount = this.tempCheckout.ids.reduce((sum: any, billId: any) => {
          const bill = this.userBills.find((b: any) => b.id === billId)
          return sum + (bill ? bill.total_payment : 0)
        }, 0)

        this.payment.amount = totalBillAmount
        this.payment.convenience_fee = selectedFee.convenience_fee || 0
        this.payment.merchant_fee = selectedFee.merchant_fee || 0
        this.payment.total_discount = 0
        this.payment.ppn = 0
        this.payment.total_amount = totalBillAmount + this.payment.convenience_fee + this.payment.merchant_fee - this.payment.total_discount + this.payment.ppn

        this.paymentMethod = false
      }
    },
    checkOutConvenience: function () {
      this.loadingBulk = true
      const data = {
        convenience_id: this.convenience_id,
        spp_user_bill_ids: this.tempCheckout.ids
      }
      Promise.all([
        customerFactory.checkoutOrder(data)
      ]).then(results => {
        if (results[0].error == false) {
          const us_order_id = results[0].data.order.us_order_id
          const order_id = results[0].data.order.id
          this.handlePayment(us_order_id, order_id)
        } else if (results[0].response.data.error == true) {
          const errorMessage = results[0].response.data.messages
          swal(errorMessage, '', 'error')
        }
        this.loadingBulk = false
      }).catch((e) => {
        this.loadingBulk = false
        console.log(e)
      }).finally(() => {
        this.loadingBulk = false
      })
    },
    bulkCheckout: function (type?: any) {
      this.resetTempCheckout()
      this.setTempCheckout(this.billIds, 'bulk')
      
      if (this.setting.ENABLE_CONVENIENCE_FEE == 'true' && type !== 'pay') {
        this.resetConvenienceFee()
        this.showModal('convenience')
      } else {
        this.loadingBulk = true
        swal({
          title: 'Apakah anda yakin?',
          text: 'Anda akan membayar tagihan terpilih.',
          icon: 'warning',
          buttons: {
            cancel: true,
            confirm: true
          },
          dangerMode: true
        })
          .then((isConfirm) => {
            if (isConfirm) {
              const data = {
                convenience_id: 0,
                spp_user_bill_ids: this.tempCheckout.ids
              }
              Promise.all([
                customerFactory.checkoutOrder(data)
              ]).then(results => {
                if (results[0]) {
                  const us_order_id = results[0].data.order.us_order_id
                  const order_id = results[0].data.order.id
                  this.handlePayment(us_order_id, order_id)
                }
              })
            } else {
              this.loadingBulk = false
            }
          })
          .catch(() => {
            this.loadingBulk = false
          }).finally(() => {
            this.loadingBulk = false
          })
      }
    },
    checkout: function (id: any, order_id: any, type?: any) {
      const ids: any = []
      this.orderId = null
      ids.push(id)
      this.resetTempCheckout()
      this.setTempCheckout(ids, 'single')
      
      if (this.setting.ENABLE_CONVENIENCE_FEE == 'true' && type !== 'pay') {
        this.resetConvenienceFee()
        this.showModal('convenience')
      } else {
        if ((order_id != undefined && !this.isCanceled(order_id)) || !this.tempCheckout.ids) {
          this.hideModal('convenience')
          const invoice_path = `/bill/invoice/${order_id[0]}`
          router.push({ path: invoice_path })
        } else {
          this.loading[id] = true
          const data = {
            convenience_id: 0,
            spp_user_bill_ids: this.tempCheckout.ids
          }
          Promise.all([
            customerFactory.checkoutOrder(data)
          ]).then(results => {
            if (results[0].error == false) {
              const us_order_id = results[0].data.order.us_order_id || null
              const order_id = results[0].data.order.id || null
              if (us_order_id && order_id) {
                this.handlePayment(us_order_id, order_id)
              } else {
                this.orderId = results[0].data.order.id
                this.bca.invoice_number = results[0].data.order.invoice_no
                this.bca.va_number = results[0].data.order.custom_field2
                this.bca.bank_name = results[0].data.order.custom_field3
                this.bca.amount = results[0].data.order.total_amount
                this.bca.convenience_fee = results[0].data.order.convenience_fee
                this.bca.merchant_fee = results[0].data.order.merchant_fee
                this.bca.total_discount = results[0].data.order.total_discount
                this.bca.ppn = results[0].data.order.ppn
                this.bca.total_payment = results[0].data.order.total_payment

                this.canUploadReference = true
                this.referenceFile = null

                this.hideModal('convenience')
                this.showModal('bca')
              }
            } else if (results[0].error == true) {
              const errorMessage = results[0].messages
              swal(errorMessage, '', 'error')
              this.loading[id] = false
            }
          }).catch((e) => {
            swal('Gagal melakukan request', '', 'error')
            console.log(e)
            this.loading[id] = false
          }).finally(() => {
            this.loading[id] = false
          })
        }
      }
    },
    handlePayment: function (us_order_id: any, order_id: any) {
      Promise.all([
        usFactory.getUSToken(us_order_id)
      ]).then(results => {
        const token_order_id = results[0].data.us_order.token
        const us_order = results[0].data.us_order
        const order = results[0].data.order
        const merchant = us_order.merchant
        const merchant_config = merchant.configs || {}
        const client_key = merchant_config.client_key || ''
        const snap_js_endpoint = merchant_config.snap_js_endpoint || ''

        if (!merchant) {
          swal('Gagal melakukan request', '', 'error')
          return
        }

        if (merchant.type == 'midtrans') {
          loadSnapJS(snap_js_endpoint, client_key, function () {
            if (typeof snap === 'undefined') {
              swal('Halaman Belum siap', '', 'error')
              return
            }

            snap.pay(token_order_id, {
              uiMode: 'qr',
              gopayMode: 'qr',
              onSuccess: function (result: any) {
                console.log('success')
                return false
              },
              onPending: function (result: any) {
                console.log('pending')
                return false
              },
              onError: function (result: any) {
                console.log('error')
                return false
              },
              onClose: function () {
                console.log('customer closed the popup without finishing the payment')
                return false
              }
            })
          })
        } else if (merchant.type == 'xendit') {
          this.xenditInvoice = us_order.link
          this.xenditModal.show()
        } else {
          const bankNames = {
            bca: 'BCA',
            panin: 'Panin',
            cimb: 'CIMB',
            bcah2h: 'BCA',
            permata: 'Permata',
            ocbc: 'OCBC',
            mandiri: 'Mandiri',
            bni: 'BNI',
            bri: 'BRI'
          }

          this.bca.orderId = us_order.order_id
          this.bca.va_number = us_order.custom_field1
          if (merchant.type.includes('offline')) {
            this.bca.va_number_nobill = us_order.custom_field2
            this.bca.bank_name = bankNames[merchant.type.split('-')[0]]
          } else {
            this.bca.bank_name = bankNames[merchant.type]
          }
          this.bca.amount = us_order.total_amount
          this.bca.convenience_fee = order.convenience_fee
          this.bca.merchant_fee = order.merchant_fee
          this.bca.total_discount = order.total_discount
          this.bca.ppn = order.ppn
          this.bca.total_payment = order.total_payment
          this.bcaModal.show()
        }
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      }).finally(() => {
        this.loadData()
        return false
      })
      return false
    },
    handleFileUpload: function (event: any) {
      const file = event.target.files[0]
      this.referenceFile = null
      if (file) {
        const orderId = this.orderId
        customerFactory.uploadReference(orderId, file).then(response => {
          if (response.error == false) {
            this.referenceFile = response.data.file_path
            event.target.value = ''
            swal('Berhasil mengupload bukti pembayaran', '', 'success')
          } else {
            swal('Gagal mengupload bukti pembayaran', '', 'error')
          }
        }).catch((e) => {
          swal('Gagal mengupload bukti pembayaran', '', 'error')
          console.log(e)
        })
      }
    },
    invoice: function (order_id: any) {
      if (order_id != undefined) {
        const invoice_path = `/bill/invoice/${order_id}`
        router.push({ path: invoice_path })
      }
    },
    formatPrice: function (value: any) {
      return Utils.toLocaleString(value)
    },
    loadSettings: function () {
      const setting_data = {
        title: 'ENABLE_CONVENIENCE_FEE'
      }
      Promise.all([
        masterDataFactory.setting_data(setting_data)
      ]).then(results => {
        const setting = results[0].data.setting
        if (setting != null) {
          this.setting.ENABLE_CONVENIENCE_FEE = setting.value
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    loadConvenienceFee: function () {
      const data = {
        school_years: '0',
        bill_types: '0',
        bill_detail_types: '0',
        classes: '0',
        months: '0',
        school: '0',
        math_operations: '0',
        order_statuses: '0',
        convenience_fee: '1',
        merchants: '0',
        custom_criterias: '0'
      }
      Promise.all([
        masterDataFactory.master_datas(data)
      ]).then(results => {
        this.convenienceFee = results[0].data.convenience_fee
      }).catch((e) => {
        console.log(e)
      })
    },
    loadFeatureConfigs: function () {
      Promise.resolve(setupFactory.getFeatureConfigs({ feature_configs: ['spp_admin_can_generate_payment'] })).then(
        (res) => {
          console.log('Feature Configs:', res.data.feature_configs)
          if ('spp_admin_can_generate_payment' in res.data.feature_configs) {
            const value = res.data.feature_configs.spp_admin_can_generate_payment
            this.adminCanGeneratePayment = value === true || value === 'true'
          }
        }
      ).catch((e) => {
        console.log(e)
      })
    },
    addSnapJS () {
      const uangsekolah = document.createElement('script')
      const instance = String(localStorage.getItem('instance'))
      uangsekolah.setAttribute('src', localStorage.getItem('base_url') + '/' + instance + '/us/snap.js')
      document.head.appendChild(uangsekolah)
    }
  },
  computed: {
    totalSelectedAmount: function () {
      let total = 0
      this.billIds.forEach((billId: any) => {
        const bill = this.userBills.find((b: any) => b.id === billId)
        if (bill) {
          total += bill.total_payment
        }
      })
      return Utils.toLocaleString(total)
    },
    promoTerm: function () {
      return ''
    },
    sortedUserBills: function () {
      return this.userBills.sort((a: any, b: any) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
    isHideElementYkck: function () {
      return [
        'tkglobalandalan',
        'kbtktarunaandalan',
        'sdglobalandalan',
        'sdtarunaandalan',
        'smpglobalandalan',
        'smptarunaandalan',
        'smatarunaandalan'
      ].includes(this.instance) === false
    }
  },
  async mounted () {
    // Check role access for /bill/* (dynamic path for bill detail)
    if (!roleAccessManager.canRead('/bill/*')) {
      swal({
        title: 'Access Denied',
        text: 'Anda tidak memiliki akses ke halaman detail tagihan siswa',
        icon: 'error'
      }).then(() => {
        this.$router.push('/loginpage')
      })
      return
    }

    // Set permission flags
    this.canUpdate = roleAccessManager.canUpdate('/bill/*')

    await this.loadDataMaster()
    this.loadSettings()
    this.loadConvenienceFee()
    this.loadFeatureConfigs()
    this.addSnapJS()
    this.instance = String(localStorage.getItem('instance'))

    // Initialize modals
    const convenienceFeeModal = document.getElementById('convenienceFeeModal')
    if (convenienceFeeModal != null) {
      this.convenienceFeeModal = new bootstrap.Modal(convenienceFeeModal)
    }
    const xenditModal = document.getElementById('xenditModal')
    if (xenditModal != null) {
      this.xenditModal = new bootstrap.Modal(xenditModal)
    }
    const bcaModal = document.getElementById('bcaModal')
    if (bcaModal != null) {
      this.bcaModal = new bootstrap.Modal(bcaModal)
    }

    // Add event listeners for modal close
    const parent = this
    if (convenienceFeeModal) {
      convenienceFeeModal.addEventListener('hidden.bs.modal', function () {
        parent.loadData()
      })
    }
    if (xenditModal) {
      xenditModal.addEventListener('hidden.bs.modal', function () {
        parent.loadData()
      })
    }
    if (bcaModal) {
      bcaModal.addEventListener('hidden.bs.modal', function () {
        parent.loadData()
      })
    }
  }
})

export default class BillDetail extends Vue {}
